import LogosSliderComponent from '../../../slices/LogosSlider'

interface Props {
	slice: any
}

export default function LogosSlider({ slice }: Props) {
	const { primary, items } = slice

	const logos = (items || [])
		.map((item: any) => {
			const logoUrl = item.logo_url?.url
			if (!logoUrl) return null
			return {
				url: logoUrl,
				alt: (item.logo_alt || item.logo_url?.alt || '').trim()
			}
		})
		.filter(Boolean)

	return (
		<LogosSliderComponent
			sliceType={slice.slice_type}
			sliceVariation={slice.variation}
			color={primary?.slider_color || '#000000'}
			logoColor={primary?.logo_color}
			speed={Number(primary?.slider_speed) || 2}
			heightDesktop={primary?.slider_height_desktop || 100}
			heightMobile={primary?.slider_height_mobile || 80}
			logos={logos}
		/>
	)
}
